import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientMypageListItem のスタイル
 */
export const hotlineClientMypageListItemStyle = tv({
    slots: {
        base: [],
        companyText: [textStyle({ color: 'textGray', size: 'sm' })],
        content: ['overflow-hidden'],
        countNumber: [
            textStyle({ color: 'base', isBold: true, size: 'lg' }),
            'translate-y-4',
        ],
        countNumberWrap: [
            'flex flex-nowrap items-end gap-x-4',
            'max-lg:translate-y-[-5px]',
        ],
        countText: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        countUnitText: [textStyle({ color: 'base', size: 'xs' })],
        countWrap: [
            'flex-grow',
            'flex items-center flex-row lg:flex-col lg:justify-center gap-8',
            'p-8 lg:py-12',
            'bg-orange-50',
            'rounded-md',
            'lg:h-full',
        ],
        deadlineText: [textStyle({ color: 'base', size: 'sm' })],
        details: ['group/details', 'bg-white', 'rounded-md', 'shadow-md'],
        firstContent: ['flex flex-col gap-y-8', 'lg:flex-grow'],
        icon: [
            'flex-shrink-0',
            'transition-transform',
            // 開いている時
            'group-open/details:rotate-180',
        ],
        secondContent: ['flex items-center flex-nowrap gap-16', 'lg:shrink-0'],
        summary: [
            'flex flex-col lg:flex-row lg:flex-nowrap gap-8 lg:gap-16',
            'p-16',
            '[&::marker]:hidden [&::-webkit-details-marker]:hidden',
        ],
        title: [
            linkTextStyle({ isBold: true, size: 'md' }),
            'block',
            'line-clamp-2 lg:line-clamp-1',
            'break-all',
        ],
        top: ['flex flex-wrap gap-8'],
    },
});
